import { postCampaignPermission } from "redux/redux-modules";
import { putResolve, select } from "redux-saga/effects";

import type { ModalCampaigns } from "../campaigns.types";
import { campaignModalsSelector } from "../selectors";

export function* addPublicPermissionAssignmentSaga() {
	const campaignModals: ModalCampaigns = yield select(campaignModalsSelector);

	if (!campaignModals.permissions) {
		return [];
	}

	yield putResolve(
		postCampaignPermission.actions.makeRequest({
			payload: {
				permission: "VIEW",
				assignee_user_group_id: null,
				assignee_user_id: null,
				campaign_id: campaignModals.permissions.id,
			},
		}),
	);

	return [];
}
